if (!customElements.get('pb-mobile-offers')) {
customElements.define('pb-mobile-offers', class extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.pb-offers-track');
    this.slides = [...this.querySelectorAll('.product-offers__item')];
    this.dots = [...this.querySelectorAll('.page-dots button')];
    this.index = 0;
    this.slides.forEach((slide, i) => {slide.hidden = i !== 0; slide.inert = i !== 0;});
    this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.show(i)));
    this.measure = () => {
      if (!this.track || !this.getBoundingClientRect().width) return;
      const height = Math.ceil(Math.max(0, ...this.slides.map(slide => {
        const content = slide.querySelector('.v-stack');
        const style = getComputedStyle(slide);
        return (content ? content.getBoundingClientRect().height : 0) + parseFloat(style.paddingTop || 0) + parseFloat(style.paddingBottom || 0);
      })));
      if (height > 0) this.track.style.setProperty('--pb-offer-height', height + 'px');
    };
    this.measure();
    if (document.fonts) document.fonts.ready.then(() => {if(this.isConnected)this.measure();});
    this.lastWidth = this.getBoundingClientRect().width;
    this.observer = new ResizeObserver(() => {
      const width = this.getBoundingClientRect().width;
      if (Math.abs(width - this.lastWidth) > 1) {this.lastWidth = width; this.measure();}
    });
    this.observer.observe(this);
    this.timer = setInterval(() => {
      if (matchMedia('(max-width:699px)').matches && !document.hidden && !this.contains(document.activeElement)) this.show((this.index + 1) % this.slides.length);
    }, 4000);
  }
  async show(next) {
    if (next === this.index || this.busy || this.slides.length < 2) return;
    this.busy = true;
    const old = this.slides[this.index], incoming = this.slides[next];
    incoming.hidden = false; incoming.inert = false; old.inert = true;
    this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === next)));
    const options = {duration:300, easing:'ease-in-out', fill:'both'};
    const out = old.animate([{transform:'translateX(0)'},{transform:'translateX(-100%)'}], options);
    const enter = incoming.animate([{transform:'translateX(100%)'},{transform:'translateX(0)'}], options);
    try {await Promise.all([out.finished, enter.finished]);} catch {}
    old.hidden = true; out.cancel(); enter.cancel();
    this.index = next; this.busy = false;
  }
  disconnectedCallback() {clearInterval(this.timer); this.observer?.disconnect();}
});
}
